export namespace IReportsEnums {
    export enum ActionTypes {
        'PAUSE' = 'PAUSE',
        'UNPAUSE' = 'UNPAUSE',
        'DELETE' = 'DELETE'
    }

	export enum ActionTypesIcon {
        'PAUSE' = 'fa-pause',
        'UNPAUSE' = 'fa-play',
        'DELETE' = 'fa-trash'
    }
}

export enum REPORT_DATE_TYPES {
	CUSTOM =            'custom',
	FROM =              'from',
	LAST =              'last',
	PREVIOUS =          'previous',
	CURRENT_WEEK =      'current_week',
	PREVIOUS_WEEK =     'previous_week',
	CURRENT_MONTH =     'current_month',
	PREVIOUS_MONTH =    'previous_month',
	PREVIOUS_3_MONTHS = 'previous_3_months',
	CURRENT_YEAR =      'current_year',
	TODAY =             'today',
	YESTERDAY =         'yesterday',
	UNLIMITED =         'unlimited',
};

export enum REPORT_SCHEDULES {
	ONLY_ONCE =          'only_once',
	EVERY_MONDAY =       'every_monday',
	EVERY_WEEKDAY =      'every_weekday',
	FIRST_OF_THE_MONTH = 'first_of_the_month',
};

export enum REPORT_ACTION_TYPES {
	EMAIL =     'email',
	SHOW =      'show',
	URL =       'url',
	BIG_QUERY = 'bigquery',
};

export enum REPORT_ACTION_FORMATS {
	JSON =   'json',
	CSV =    'csv',
	EXCEL =  'excel',
	INLINE = 'inline',
};

export enum REPORT_TRANSACTION_STATUS_FORMATS {
	PENDING =    'PENDING',
	FB_PENDING = 'FB_PENDING',
	PROCESSED =  'PROCESSED',
	REJECTED =   'REJECTED',
	CANCELLED =  'CANCELLED'
};
